import { render, staticRenderFns } from "./CustomPage.vue?vue&type=template&id=42ce24a4&"
import script from "./CustomPage.vue?vue&type=script&lang=js&"
export * from "./CustomPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomPage.vue?vue&type=style&index=0&id=42ce24a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports